<template>
  <div
    class="relative w-full overflow-hidden rounded-3xl"
    @click="handleClick"
  >
    <div
      class="absolute inset-0 w-full bg-cover bg-no-repeat"
      :style="{ backgroundImage: `url(${friendsOfferBg})` }"
    ></div>

    <div
      class="absolute inset-0"
      style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 4) 90%
        );
      "
    ></div>

    <div
      class="relative flex min-h-64 w-full flex-col justify-between gap-2 p-4"
      :class="{
        'items-center text-center': isCentered,
        'pb-10': isCentered && !isSingleOffer,
      }"
    >
      <div class="flex items-center gap-2 self-start">
        <FreedomPrimeTag
          :alt="t('specialOffer.friends.tags.friends')"
          class="h-7 w-auto"
        />
        <SpecialOfferTag :title="t('specialOffer.friends.tags.discounts')" />
      </div>

      <div class="flex flex-col gap-1" :class="{ 'items-center': isCentered }">
        <p class="text-static-white text-lg font-semibold">
          {{ t('specialOffer.friends.title') }}
        </p>
        <p class="text-static-white/80 text-sm">
          {{ t('specialOffer.friends.description') }}
        </p>
        <button
          type="button"
          class="text-text-neutral-secondary bg-situational-lightgrey mt-2 w-fit rounded-2xl px-6 py-2 text-xs font-medium"
          @click.stop="handleClick"
        >
          {{ t('specialOffer.friends.button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { freedomApp, SupportedMiniApps } from 'freedom-shared';

  import { analyticsEventsLib } from '@/shared/lib';

  import friendsOfferBg from '../assets/friends-offer-bg.webp';
  import FreedomPrimeTag from '../assets/friends-tag.svg?component';
  import SpecialOfferTag from './SpecialOfferTag.vue';

  const props = withDefaults(
    defineProps<{
      source?: 'main' | 'all_special_offers';
      isCentered?: boolean;
      isSingleOffer?: boolean;
    }>(),
    {
      source: 'main',
    },
  );

  const { t } = useI18n();

  /**
   * Deep-link into Arbuz mini app; we keep the return URL explicit so the
   * super app can bring the user back to the Avia travel flow.
   */
  const returnUrl = `https://mini-app.arbuz.kz/subscription?prime_return_url=https://bankffin.kz/services/${SupportedMiniApps.TRAVEL}`;

  const handleClick = () => {
    analyticsEventsLib.specialOfferFriendsClicked({ source: props.source });
    freedomApp.lib.openMiniApp(SupportedMiniApps.ARBUZ, returnUrl);
  };
</script>
